/**
 *  world-map.js
 *
 *  Decorate world map and generate tooltips for Where We Work Map commponent.
 */

export default function () {
  let mapAreas=document.querySelectorAll(".world-map__map svg g");
  let mapContents=document.querySelectorAll(".world-map .world-map__stats");


  [...mapContents].forEach(mapContent => {
    [...mapAreas].forEach(mapArea => {
      if (mapArea.getAttribute('id')===mapContent.getAttribute('data-code')) {
        mapArea.classList.add('hoverable');
      }
    });
  });

  if (mapAreas.length>0) {
    let element=document.querySelector('.world-map__map svg g#qa path');
    element.classList.add("active");

    for (let mapArea of mapAreas) {
      mapArea.addEventListener('click', (e) => {
        const et=e.target;
        const active=document.querySelector(".active");
        element.classList.remove("active");

        if (active) {
          active.classList.remove("active");
        }
        et.classList.add("active");

        let allContent=document.querySelectorAll('.world-map__stats');

        for (let content of allContent) {
          if (content.getAttribute('data-code')===mapArea.getAttribute('id')) {
            content.style.display="block";
          } else {
            content.style.display="none";
          }
        }
      });
    }
  }
}
